export default "<ion-app>\n  <ion-router-outlet id=\"main\" style=\"background-color: #f7f7f7;\"></ion-router-outlet>\n</ion-app>\n"